export const zipOnlyTestTreatment = 'testA';
export const zipAndEmailTestTreatment = 'testB';

export const zipCodeCta = 'Get Your Price';
export const bookingCta = 'Book Now';
